export const statesErrorHeading = 'We’re Sorry';
export const statesErrorMessage =
  'Progressive Leasing is not available in Minnesota, New Jersey, Vermont, Wisconsin, and Wyoming.';

export const limitExceededErrorHeading = 'Cart Total Exceeds Approval Limit';
export const limitExceededErrorMessage =
  'Please contact your Sleep Expert to adjust your cart.';

export const progressiveTransactionType = 'Checkout';
export const progressiveCardInfoAttribute = 'Progressive Leasing';
export const progressiveAddressLocalStorageKey = 'progressive_home_address';

// Following phone format is used on customer info section at checkout page
export const customerInfoPhoneRegex =
  /^\(?([2-9][0-8][0-9])\)?[ . ]?([2-9][0-9]{2})[-. ]?([0-9]{4})(\s*x[0-9]+)?$/;

export const ONLINEPAY_STORE_ID = '099011';
export const PROGRESSIVE_LINE_TYPE_LEASE = 'LeaseItem';
export const PROGRESSIVE_LINE_TYPE_DELIVERY = 'DeliveryFee';
export const PROGRESSIVE_LINE_SKU_DELIVERY = 'Delivery Charge';
export const PROGRESSIVE_LINE_SKU_RECYCLING = 'Recycling Fee';
export const PROGRESSIVE_LINE_DESC_DELIVERY = 'Delivery Charge';
export const PROGRESSIVE_LINE_DESC_RECYCLING = 'Recycling Fee';
export const PROGRESSIVE_LINE_DESC_WARRANTY = 'Extend charge';
export const PROGRESSIVE_TRANSACTION_TYPE = 'Checkout';
export const PROGRESSIVE_TENDER_TYPE = 'Progressive';
export const POST_MESSAGE_NAME = 'message';
export const PROGRESSIVE_PROCESS_COMPLETE_MESSAGE = 'Post Process: Complete';
export const PROGRESSIVE_ERROR_EVENT_LABELS = {
  nonLeasableItem: 'non-leasable item in cart',
  blockedState: 'not available in your state',
  leaseInfoNotFound: 'lease information not found',
  cartTotalExceedsLimit: 'cart total exceeds approval limit',
  addressMismatch: "address doesn't match",
  cartTotalBelowMinimum: 'minimum cart must exceed 300',
};
